import { render, staticRenderFns } from "./firma-izvestaj.vue?vue&type=template&id=388aaf3b"
import script from "./firma-izvestaj.vue?vue&type=script&lang=js"
export * from "./firma-izvestaj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports